<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">单据</label>
          </div>
          <div class="weui-cell__bd">{{form.mn_name}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">前缀码</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.mn_leadcode" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">流水规则</label>
          </div>
          <div class="weui-cell__bd">
            <select v-model="form.mn_rule" class="weui-select">
              <option value="yyyymmdd">年月日</option>
              <option value="yyyymm">年月</option>
              <option value="无">无</option>
            </select>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">流水长度</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" v-model="form.mn_number" placeholder="请填写" />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.form = to.params.initData;
    });
  },
  methods: {
    save() {
      var me = this,
        main = me.form;
      if (!main.mn_number) {
        me.$weui.topTips("请填写流水长度", 3000);
      } else {
        me.$loading({
          url: "/api/commons/number/save",
          method: "POST",
          jsonData: main
        })
          .then(function(res) {
            if (res.success) {
              me.$weui.toast("设置成功", 2000);
              me.$router.back();
            } else {
              me.$weui.topTips(res.message, 3000);
            }
          })
          .catch(function() {
            me.$weui.topTips("设置失败", 3000);
          });
      }
    }
  }
};
</script>